/** Component page that takes the feedback from the user on this particular stage and stores it away.  
 */
import React from 'react';
import { FormControl, Form, Button } from 'react-bootstrap';
import StageManager from '../../services/stageManager';
import Header from '../header/Header';

export default class Feedback extends React.Component {
    constructor() {
        super();
        this.stageMan = new StageManager();
    }

    render() {
        let stageObj = this.stageMan.getStageByIndex(this.props.location.state.stage);
        let descText = stageObj[this.props.location.state.type].desc;
        return (<div><Header history={this.props.history} />
            <div className={"pageContainer"}>
                <h2>Stage Feedback</h2>
                <p>{descText}</p>
                <Form>
                    <FormControl as="textarea" size={"lg"} placeholder="Feedback"></FormControl>
                    <br />
                    <Button /*onClick={}*/>Send Feedback</Button><span>&nbsp;</span>
                    <Button onClick={this.props.history.goBack}>Cancel</Button>
                </Form>
            </div>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Feedback.js